module.exports = __webpack_public_path__ + "static/media/CitySunshine.4f813c6c.mp3";